export default __webpack_public_path__ + "static/media/glrc-course.baking-basics.74c8a8f1.png";